/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	(function () {
	  (0, _module.disableTransition)();
	  (0, _module.preLoad)();
	  (0, _module.anchorLink)();
	  (0, _module.animParticle)();
	  (0, _module.pickupSlider)();
	  (0, _module.toggleNav)();
	  (0, _module.toggleTotop)();
	  (0, _module.animScroll)();
	  (0, _module.animLoad)();
	  (0, _module.gachaSwitch)();
	  (0, _module.imageModal)();
	  (0, _module.movieModal)();
	})();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.movieModal = exports.scheduleAnchor = exports.loadingExit = exports.imageModal = exports.gachaSwitch = exports.animLoad = exports.animScroll = exports.toggleTotop = exports.toggleNav = exports.pickupSlider = exports.animParticle = exports.anchorLink = exports.preLoad = exports.disableTransition = void 0;
	var breakPoint = 767;
	var resizeFlag = false;
	var windowWidth = window.innerWidth;
	var windowHeight = window.innerHeight;
	var windowWidthJ = $(window).width(); // ------------------------------------------------------------------------
	// disableTransition
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	var disableTransition = function disableTransition() {
	  $(window).on("load", function () {
	    $("body").removeClass("preload");
	  });
	  setTimeout(function () {
	    $("body").removeClass("preload");
	  }, 9000);
	}; // ------------------------------------------------------------------------
	// preLoad
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.disableTransition = disableTransition;
	
	var preLoad = function preLoad() {
	  $(window).on("load", function () {
	    $("body").css("opacity", "1");
	  });
	  setTimeout(function () {
	    $("body").css("opacity", "1");
	  }, 9000);
	}; // ------------------------------------------------------------------------
	// anchorLink
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.preLoad = preLoad;
	
	var anchorLink = function anchorLink() {
	  $("a[href^='#']").on("click", function () {
	    var linkSpeed = 800;
	    var linkHref = $(this).attr("href");
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkAdjust = 0;
	    var linkPosition = linkTarget.offset().top;
	    $("html, body").animate({
	      scrollTop: linkPosition - linkAdjust
	    }, linkSpeed, "swing");
	    return false;
	  });
	}; // ------------------------------------------------------------------------
	// animParticle
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.anchorLink = anchorLink;
	
	var animParticle = function animParticle() {
	  PIXI.settings.CAN_UPLOAD_SAME_BUFFER = false;
	
	  var animParticles = function animParticles(target, img) {
	    var elm = document.getElementById(target);
	    var elmHeight = elm.clientHeight;
	    var windowWidth = window.innerWidth;
	    var windowHeight = window.innerHeight;
	    var mouse = {
	      x: 0,
	      y: 0
	    };
	    var exTrg = 0;
	    var exEndTrg = 0;
	    var beforePos = 0;
	    var app = new PIXI.Application({
	      width: windowWidth,
	      height: windowHeight,
	      transparent: true,
	      preserveDrawingBuffer: true
	    });
	    app.stage.interactive = true;
	    elm.appendChild(app.view);
	    var sprites = new PIXI.ParticleContainer(10, {
	      scale: true,
	      position: true,
	      alpha: true,
	      autoResize: true
	    });
	    app.stage.addChild(sprites);
	    var particles = [];
	    var spritesValue = '';
	
	    if (matchMedia('(max-width: 798px)').matches) {
	      spritesValue = 5;
	    } else {
	      spritesValue = 10;
	    }
	
	    var totalSprites = app.renderer instanceof PIXI.Renderer ? spritesValue : spritesValue;
	    var alphaflags = [];
	    var alphaflag;
	
	    for (var i = 0; i < totalSprites; i++) {
	      var particle = PIXI.Sprite.from(img);
	      var colors = [0x00FFFF, 0xEB3344, 0x3344A7, 0x69FFD1, 0x33A7FF, 0xFFDA00];
	      particle.tint = colors[Math.floor(Math.random() * colors.length)];
	      particle.anchor.set(0.5);
	
	      if (windowWidth > 768) {
	        particle.scale.set(0.1 + Math.random() * 0.4);
	      } else {
	        particle.scale.set(0.1 + Math.random() * 0.2);
	      }
	
	      particle.x = Math.random() * app.screen.width;
	      particle.y = Math.random() * app.screen.height;
	      particle.direction = Math.random() * Math.PI * 2;
	      particle.turningSpeed = Math.random() - 0.1;
	      particle.speed = (2 + Math.random() * 2) * 0.2;
	      particle.offset = Math.random() * 100;
	      particle.alpha = Math.random() * 0.1;
	      particles.push(particle);
	      sprites.addChild(particle);
	      var _alphaflag = 2;
	      alphaflags.push(_alphaflag);
	    }
	
	    function onPointerMove(e) {
	      mouse.x = e.data.global.x;
	      mouse.y = e.data.global.y;
	    }
	
	    app.stage.on('mousemove', onPointerMove).on('touchmove', onPointerMove);
	    var particleBoundsPadding = 400;
	    var particleBounds = new PIXI.Rectangle(-particleBoundsPadding, -particleBoundsPadding, app.screen.width + particleBoundsPadding * 2, app.screen.height + particleBoundsPadding * 2);
	    var tick = 0;
	    app.ticker.add(function () {
	      for (var _i = 0; _i < particles.length; _i++) {
	        var _particle = particles[_i];
	        _particle.direction += _particle.turningSpeed * 0.01;
	        _particle.x += Math.sin(_particle.direction) * (_particle.speed * _particle.scale.y);
	        _particle.y += Math.cos(_particle.direction) * (_particle.speed * _particle.scale.y); // opacity
	
	        if (_particle.alpha > 0.2) {
	          alphaflags[_i] = 1;
	        } else if (_particle.alpha < 0.01) {
	          alphaflags[_i] = 0;
	        }
	
	        if (alphaflags[_i] == 1) {
	          _particle.alpha -= 0.001 * _particle.speed;
	        } else if (alphaflags[_i] == 0 || alphaflags[_i] == 2) {
	          _particle.alpha += 0.001 * _particle.speed;
	        } // overflow
	
	
	        if (_particle.x < particleBounds.x) {
	          _particle.x += particleBounds.width;
	        } else if (_particle.x > particleBounds.x + particleBounds.width) {
	          _particle.x -= particleBounds.width;
	        }
	
	        if (_particle.y < particleBounds.y) {
	          _particle.y += particleBounds.height;
	        } else if (_particle.y > particleBounds.y + particleBounds.height) {
	          _particle.y -= particleBounds.height;
	        } // mouse
	
	
	        if (mouse.x - _particle.x < 100 && mouse.x - _particle.x > -100 && mouse.y - _particle.y < 100 && mouse.y - _particle.y > -100) {
	          _particle.x += (mouse.x - _particle.x) * _particle.speed * 0.025;
	          _particle.y += (mouse.y - _particle.y) * _particle.speed * 0.025;
	        }
	      }
	
	      tick += 0.1;
	    });
	    $(window).on("load resize", function () {
	      app.renderer.resize(window.innerWidth, window.innerHeight);
	      particleBounds.width = app.screen.width + particleBoundsPadding * 2;
	      particleBounds.height = app.screen.height + particleBoundsPadding * 2;
	    });
	    $(window).on("load scroll", function () {
	      var scrollHeight = $(this).scrollTop();
	
	      for (var _i2 = 0; _i2 < particles.length; _i2++) {
	        var _particle2 = particles[_i2];
	        var distance = scrollHeight - beforePos;
	
	        if (scrollHeight > beforePos) {
	          _particle2.y -= distance * (_particle2.scale.y * 0.5);
	        } else {
	          _particle2.y -= distance * (_particle2.scale.y * 0.5);
	        }
	      }
	
	      beforePos = scrollHeight;
	    });
	  };
	
	  var userAgent = window.navigator.userAgent.toLowerCase();
	
	  if (/iPad|Macintosh/i.test(navigator.userAgent) && 'ontouchend' in document || userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1) {
	    animParticles('particles', '/5th/assets/images/common/tex_particle.png');
	  } else {
	    // animParticles('particles', '/assets/images/common/tex_particle.png');
	    animParticles('particles', '/5th/assets/images/common/tex_particle.png');
	  }
	}; // ------------------------------------------------------------------------
	// pickupSlider
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.animParticle = animParticle;
	
	var pickupSlider = function pickupSlider() {
	  var puSlider = new Swiper('.pickup-list', {
	    speed: 600,
	    loop: true,
	    grabCursor: true,
	    slidesPerView: "auto",
	    initialSlide: 0,
	    preventLinks: false,
	    simulateTouch: true,
	    slideToClickedSlide: false,
	    navigation: {
	      nextEl: ".pickup-nav_next",
	      prevEl: ".pickup-nav_prev"
	    },
	    pagination: {
	      el: '.pickup-nav_dot',
	      type: 'bullets',
	      clickable: true
	    }
	  });
	}; // ------------------------------------------------------------------------
	// toggleNav
	// ------------------------------------------------------------------------
	
	
	exports.pickupSlider = pickupSlider;
	
	var toggleNav = function toggleNav() {
	  var flag = 0;
	  var currentPos = 0;
	  $(".header-hamburger").on("click", function () {
	    $(".menu-overlay").toggleClass("open");
	    $(".header-hamburger").toggleClass("open");
	
	    if (/iPad|Macintosh/i.test(navigator.userAgent) && 'ontouchend' in document) {// 何もしない
	    } else {
	      if (flag == 0) {
	        var scrollElem = document.scrollingElement || document.documentElement;
	        currentPos = scrollElem.scrollTop;
	        $("body").css("position", "fixed").css("top", -currentPos);
	        flag = 1;
	      } else {
	        $("body").css("position", "").css("top", "");
	        document.documentElement.scrollTop = currentPos;
	        flag = 0;
	      }
	    }
	  });
	}; // ------------------------------------------------------------------------
	// toggleTotop
	// ------------------------------------------------------------------------
	
	
	exports.toggleNav = toggleNav;
	
	var toggleTotop = function toggleTotop(type) {
	  var visibleHeight = $('body').outerHeight();
	
	  if ($(".idx-Pickup")[0]) {
	    gsap.to('.st-Totop', {
	      scrollTrigger: {
	        trigger: ".idx-Pickup",
	        start: 'top center',
	        end: function end() {
	          return visibleHeight;
	        },
	        toggleClass: {
	          targets: ".st-Totop",
	          className: "visible"
	        }
	      }
	    });
	  } else {
	    gsap.to('.st-Totop', {
	      scrollTrigger: {
	        trigger: ".sw-Box",
	        start: 'top center',
	        end: function end() {
	          return visibleHeight * 1.5;
	        },
	        toggleClass: {
	          targets: ".st-Totop",
	          className: "visible"
	        }
	      }
	    });
	  }
	}; // ------------------------------------------------------------------------
	// animScroll
	// ------------------------------------------------------------------------
	
	
	exports.toggleTotop = toggleTotop;
	
	var animScroll = function animScroll() {
	  var margin = 0;
	
	  if (matchMedia('(max-width: 768px)').matches) {
	    margin = 150;
	  } else {
	    margin = 300;
	  }
	
	  $(".anm-fadeinup").each(function (i, node) {
	    gsap.to(node, {
	      scrollTrigger: {
	        trigger: node,
	        start: 'top bottom-=' + margin,
	        toggleClass: {
	          targets: node,
	          className: "animated"
	        },
	        once: true
	      }
	    });
	  });
	}; // ------------------------------------------------------------------------
	// animScroll
	// ------------------------------------------------------------------------
	
	
	exports.animScroll = animScroll;
	
	var animLoad = function animLoad() {
	  $(window).on("load", function () {
	    $(".anm-ld").toggleClass("animated");
	  });
	}; // ------------------------------------------------------------------------
	// gachaSwitch
	// ------------------------------------------------------------------------
	
	
	exports.animLoad = animLoad;
	
	var gachaSwitch = function gachaSwitch() {
	  $('.gacha-item_button,.multi-item_button').on('click', function () {
	    var index = $(this).data("index");
	    var target = $(this).data("target");
	    console.log(target);
	    $('#buttons-' + target + ' a').removeClass('current');
	    $(this).addClass("current");
	    $('#illusts-' + target + ' a').removeClass('current');
	    $('#illusts-' + target + ' .illust-' + index).addClass('current');
	  });
	}; // ------------------------------------------------------------------------
	// imageModal
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.gachaSwitch = gachaSwitch;
	
	var imageModal = function imageModal() {
	  var targetSrc = "";
	  var trg = 0;
	  $('.gacha-item_thumb a,.gallery-item,.multi-item_thumb a').on('click', function () {
	    trg = 1;
	    targetSrc = $(this).data('src');
	    $('.sw-Modal').toggleClass('open');
	    $('.modal-wrapper img').remove();
	    $('.modal-wrapper').append('<img src="' + targetSrc + '">');
	
	    if (navigator.userAgent.indexOf('iPhone') > 0 || navigator.userAgent.indexOf('Android') > 0 && navigator.userAgent.indexOf('Mobile') > 0 || navigator.userAgent.indexOf('iPad') > 0 || navigator.userAgent.indexOf('Android') > 0) {
	      $("meta[name=viewport]").attr('content', 'width=device-width, initial-scale=1,minimum-scale=1, maximum-scale=2, user-scalable=yes');
	    } // console.log(targetIndex);
	
	  });
	  $('.sw-Modal_Close , .sw-Modal').on('click', function () {
	    trg = 0;
	    $(".sw-Modal").removeClass("open");
	
	    if (navigator.userAgent.indexOf('iPhone') > 0 || navigator.userAgent.indexOf('Android') > 0 && navigator.userAgent.indexOf('Mobile') > 0 || navigator.userAgent.indexOf('iPad') > 0 || navigator.userAgent.indexOf('Android') > 0) {
	      $("meta[name=viewport]").attr('content', 'width=device-width, initial-scale=1,minimum-scale=1, maximum-scale=1, user-scalable=yes');
	    }
	  });
	}; // ------------------------------------------------------------------------
	// loadingExit
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.imageModal = imageModal;
	
	var loadingExit = function loadingExit() {
	  $('.st-Loading').height(windowHeight);
	  $(window).on('load', function () {
	    $('.st-Container').css('visibility', 'visible');
	    $('.st-Loading').toggleClass('exit');
	    setTimeout(function () {// $('.st-Loading').css('display', 'none');
	    }, 600);
	  });
	}; // ------------------------------------------------------------------------
	// scheduleAnchor
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.loadingExit = loadingExit;
	
	var scheduleAnchor = function scheduleAnchor() {
	  $(window).on('load', function () {
	    var listHeight = $(".cld-Schedule").outerHeight() + $("#date-26").outerHeight();
	
	    var replaceTotop = function replaceTotop() {
	      $('.st-Totop').toggleClass('replace');
	    };
	
	    gsap.to(".cld-Schedule_Anchor", {
	      scrollTrigger: {
	        trigger: ".cld-Schedule",
	        start: 'top center',
	        end: function end() {
	          return listHeight;
	        },
	        toggleClass: {
	          targets: ".cld-Schedule_Anchor",
	          className: "visible"
	        },
	        onEnter: function onEnter() {
	          return replaceTotop();
	        },
	        onEnterBack: function onEnterBack() {
	          return replaceTotop();
	        },
	        onLeave: function onLeave() {
	          return replaceTotop();
	        },
	        onLeaveBack: function onLeaveBack() {
	          return replaceTotop();
	        }
	      }
	    });
	    var areaHeight = [$("#date-06").outerHeight() + $("#date-06").offset().top - $("#date-01").offset().top, $("#date-13").outerHeight() + $("#date-13").offset().top - $("#date-07").offset().top, $("#date-20").outerHeight() + $("#date-20").offset().top - $("#date-14").offset().top, $("#date-25").outerHeight() + $("#date-25").offset().top - $("#date-21").offset().top];
	    var headitem = gsap.utils.toArray([".date-01", ".date-07", ".date-14", ".date-21"]);
	    headitem.forEach(function (elm, idx) {
	      gsap.to(elm, {
	        scrollTrigger: {
	          trigger: elm,
	          start: 'top center',
	          end: "+=" + areaHeight[idx],
	          toggleClass: {
	            targets: ".anchor-button-" + idx,
	            className: "current"
	          }
	        }
	      });
	    });
	  });
	}; // ------------------------------------------------------------------------
	// movieModal
	// ------------------------------------------------------------------------
	
	
	exports.scheduleAnchor = scheduleAnchor;
	
	var videoControl = function videoControl(action, target) {
	  var $playerWindow = $(target)[0].contentWindow;
	  $playerWindow.postMessage('{"event":"command","func":"' + action + '","args":""}', '*');
	};
	
	var movieModal = function movieModal() {
	  var ua = navigator.userAgent;
	  $("[data-youtube]").on("click", function () {
	    var youtubeId = $(this).data("youtube");
	    var embedUrl = "https://www.youtube.com/embed/" + youtubeId + "?autoplay=1&enablejsapi=1";
	    $('.modal-wrapper img').remove();
	    $('.modal-wrapper').append('<iframe id="modal-youtube" width="560" height="315" src="" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>');
	    $(".sw-Modal").toggleClass("open");
	    $(".sw-Modal_Inner").toggleClass("movie");
	    $('#modal-youtube').attr("src", embedUrl);
	    $('#modal-youtube').on('load', function () {
	      if (/android/i.test(ua) || matchMedia('(min-width: 768px)').matches) {
	        videoControl("playVideo", '#modal-youtube');
	        videoControl("unMute", '#modal-youtube');
	      }
	    });
	    $('.sw-Modal_Close , .sw-Modal').on('click', function () {
	      setTimeout(function () {
	        $('.modal-wrapper iframe').remove();
	        $(".sw-Modal_Inner").removeClass("movie");
	      }, 400);
	    });
	  });
	};
	
	exports.movieModal = movieModal;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// gallery/app.bundle.js